import { BaseMethod } from "./_Base";
export class PointsCountExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [["string", "path to node"]];
  }
  findDependency(index_or_path) {
    return this.createDependencyFromIndexOrPath(index_or_path);
  }
  processArguments(args) {
    return new Promise(async (resolve, reject) => {
      if (args.length == 1) {
        const index_or_path = args[0];
        let container;
        try {
          container = await this.getReferencedNodeContainer(index_or_path);
        } catch (e) {
          reject(e);
          return;
        }
        if (container) {
          const value = container.pointsCount();
          resolve(value);
        }
      } else {
        resolve(0);
      }
    });
  }
}
